import { createUseStyles } from 'react-jss';

const styles = {
  button: {
    margin: '0.2rem'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'ForwardQuery'
});
